// Deliberately not the shared ADMIN_BASE: that falls back to the hardcoded
// production host for any origin it cannot rewrite — including local dev,
// which runs on local-admin.cuemath.com. Every other admin deep link is a
// lookup, but this one opens a form that WRITES KB drafts, so a local build
// must never be handed the prod URL. No resolvable non-prod host => no link.
const resolveBulkUploadBase = () => {
  if (typeof window !== 'undefined' && window.location.hostname.includes('leap-admin.')) {
    const { protocol, hostname } = window.location;
    return `${protocol}//${hostname.replace('leap-admin.', 'admin.')}`;
  }
  return null;
};

const bulkUploadBase = resolveBulkUploadBase();

export const KNOWLEDGE_BASE_BULK_UPLOAD_URL = bulkUploadBase
  ? `${bulkUploadBase}/chatbackend/admin/bulk-knowledge-base-upload/`
  : null;
